export type PlanetKey =
  | 'sun'
  | 'moon'
  | 'mercury'
  | 'venus'
  | 'mars'
  | 'jupiter'
  | 'saturn'
  | 'uranus'
  | 'neptune';

export const planetOrder: PlanetKey[] = [
  'sun',
  'moon',
  'mercury',
  'venus',
  'mars',
  'jupiter',
  'saturn',
  'uranus',
  'neptune',
];

export const planetColors: Record<PlanetKey, string> = {
  sun: '#FFE5A0',       // pastel gold (matching landing page)
  moon: '#E8E4F0',      // lavender silver (matching landing page)
  mercury: '#B8E6F5',   // sky blue (matching landing page)
  venus: '#FFD4E5',     // light pink (matching landing page)
  mars: '#FF9A8B',      // coral red (matching landing page)
  jupiter: '#C9B5E8',   // light purple (matching landing page)
  saturn: '#9B7BC8',   // medium purple (matching landing page)
  uranus: '#7FE8E8',   // turquoise (matching landing page)
  neptune: '#9BB5FF',   // light blue (matching landing page)
};

export const planetSymbols: Record<PlanetKey, string> = {
  sun: '☉',
  moon: '☽',
  mercury: '☿',
  venus: '♀',
  mars: '♂',
  jupiter: '♃',
  saturn: '♄',
  uranus: '⛢',
  neptune: '♆',
};

export const agentToPlanetKey = (agentName: string): PlanetKey | null => {
  const a = agentName.toLowerCase();
  if (a.includes('sun')) return 'sun';
  if (a.includes('moon')) return 'moon';
  if (a.includes('mercury')) return 'mercury';
  if (a.includes('venus')) return 'venus';
  if (a.includes('mars')) return 'mars';
  if (a.includes('jupiter')) return 'jupiter';
  if (a.includes('saturn')) return 'saturn';
  if (a.includes('uranus')) return 'uranus';
  if (a.includes('neptune')) return 'neptune';
  return null;
};

export const agentColor = (agentName: string): string => {
  const key = agentToPlanetKey(agentName);
  if (key) return planetColors[key];
  if (agentName.toLowerCase().includes('moderator') || agentName.toLowerCase().includes('aivaris')) return '#E5E7EB'; // light gray
  if (agentName.toLowerCase().includes('time')) return '#F59E0B'; // amber for time
  return '#8B5CF6'; // default cosmic purple
};


